import React, { useEffect, useRef, useState } from "react";
import { auth } from "../../config/firebaseConfig";
import { signOut } from "firebase/auth";

const INACTIVITY_LIMIT_MS = 5 * 60 * 1000; // 5 minutes

const AdminHeader = () => {
  const timerRef = useRef();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleLogout = async () => {
    try {
      // Sign out from Firebase Auth
      await signOut(auth);
      
      // Clear all local storage
      localStorage.clear();
      
      // Redirect to auth page
      window.location.href = '/auth';
    } catch (error) {
      console.error("Logout error:", error);
      // Even if there's an error, clear local data and redirect
      localStorage.clear();
      window.location.href = '/auth';
    }
  };

  // Reset inactivity timer
  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setShowLogoutModal(true);
    }, INACTIVITY_LIMIT_MS);
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer();
    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <>
      <header style={{ padding: '1rem', background: '#222', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2 style={{ margin: 0 }}>Admin Panel</h2>
        <button
          onClick={handleLogout}
          style={{ background: 'linear-gradient(90deg, #b71c1c 60%, #f44336 100%)', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 24px', fontWeight: 700, fontSize: 16, cursor: 'pointer', marginLeft: 24 }}
        >
          Logout
        </button>
      </header>
      {showLogoutModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999
        }}>
          <div style={{ background: '#23272f', borderRadius: 12, padding: 32, minWidth: 340, boxShadow: '0 4px 24px #0008', color: '#fff', textAlign: 'center' }}>
            <div style={{ fontSize: 20, marginBottom: 18, fontWeight: 600 }}>Logged out due to inactivity</div>
            <div style={{ marginBottom: 24, fontSize: 16 }}>You have been logged out for security reasons.</div>
            <button
              onClick={handleLogout}
              style={{ background: 'linear-gradient(90deg, #b71c1c 60%, #f44336 100%)', color: '#fff', border: 'none', borderRadius: 6, padding: '10px 32px', fontWeight: 700, fontSize: 16, cursor: 'pointer' }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminHeader;
